/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FriendInviteResponse } from './FriendInviteResponse';
import {
    FriendInviteResponseFromJSON,
    FriendInviteResponseFromJSONTyped,
    FriendInviteResponseToJSON,
    FriendInviteResponseToJSONTyped,
} from './FriendInviteResponse';

/**
 * 
 * @export
 * @interface CreateFriendInviteResponse
 */
export interface CreateFriendInviteResponse {
    /**
     * 
     * @type {FriendInviteResponse}
     * @memberof CreateFriendInviteResponse
     */
    invite: FriendInviteResponse;
}

/**
 * Check if a given object implements the CreateFriendInviteResponse interface.
 */
export function instanceOfCreateFriendInviteResponse(value: object): value is CreateFriendInviteResponse {
    if (!('invite' in value) || value['invite'] === undefined) return false;
    return true;
}

export function CreateFriendInviteResponseFromJSON(json: any): CreateFriendInviteResponse {
    return CreateFriendInviteResponseFromJSONTyped(json, false);
}

export function CreateFriendInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFriendInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invite': FriendInviteResponseFromJSON(json['invite']),
    };
}

export function CreateFriendInviteResponseToJSON(json: any): CreateFriendInviteResponse {
    return CreateFriendInviteResponseToJSONTyped(json, false);
}

export function CreateFriendInviteResponseToJSONTyped(value?: CreateFriendInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invite': FriendInviteResponseToJSON(value['invite']),
    };
}

